import { forwardRef, useEffect, useImperativeHandle, useRef } from "react"
import $ from 'jquery';
import { nextTick } from "process";

export const FakeScrollBar = forwardRef<{ reset: () => void }>(function (props: {}, ref) {
    const rootRef = useRef<HTMLDivElement>(null);
    const contentRef = useRef<HTMLDivElement>(null);


    useImperativeHandle(ref, () => ({
        reset: () => {
            setTimeout(() => {
                const current = rootRef.current;
                if (current) {
                    const parent = rootRef.current?.parentElement;;
                    if (parent) {
                        contentRef.current!.style.width = parent.scrollWidth + 'px';
                        current.scrollLeft = parent.scrollLeft;
                        current.style.left = parent.scrollLeft + 'px';
                    }
                }
            }, 1000);
        }
    }));

    useEffect(() => {
        const current = rootRef.current;
        let onScroll: any;
        let parent: HTMLElement | null = null;

        if (current) {
            parent = rootRef.current?.parentElement;
            if (parent) {
                parent.style.position = 'relative';
                onScroll = () => {
                    if (parent) {
                        contentRef.current!.style.width = parent.scrollWidth + 'px';
                        current.scrollLeft = parent.scrollLeft;
                        current.style.left = parent.scrollLeft + 'px';
                    }
                }

                setTimeout(() => {
                    if (parent) {
                        contentRef.current!.style.width = parent.scrollWidth + 'px';
                    }
                }, 3000);

                $(parent).on("scroll", onScroll)
            }
        }


        return () => {
            if (onScroll && parent) {
                $(parent).off("scroll", onScroll)
            }
        }
    }, []);

    return (<div ref={rootRef}
        style={{ position: 'absolute', pointerEvents: 'none', left: 0, top: '-0.35rem', width: '100%', height: '1rem', overflow: "auto" }}>
        <div style={{ height: '1px' }} ref={contentRef}>
        </div>
    </div>)
});